module.exports = __webpack_public_path__ + "static/media/k11.08d3b6b2.jpg";